import React from 'react';

import { Icon } from '../../icon';
import { IconProps } from '../../icon/types';

export const PlusIcon = (props: IconProps) => (
  <Icon viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fill="currentColor"
      d="M19 11h-6V5a1 1 0 0 0-2 0v6H5a1 1 0 0 0 0 2h6v6a1 1 0 0 0 2 0v-6h6a1 1 0 0 0 0-2"
    />
  </Icon>
);
